export default function config(
  state = {
    name: 'Hedgeblue',
    description: '',
    url: 'https://hedgeblue.com',
    layout: 'layout-1',
    collapsed: false,
    backdrop: false,
  },
  action
) {
  switch (action.type) {
    case 'SET_CONFIG':
      return {
        ...state,
        ...action.config,
      }
    case 'SET_CONFIG_KEY':
      return {
        ...state,
        [`${action.key}`]: action.value,
      }
    default:
      return state
  }
}
